import { Box, Button, styled, Typography } from '@mui/material';

export const ModalContainer = styled(Box)(
  ({ theme }) => `
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      border-bottom: 1px solid ${theme.palette.primary.light};
  `,
);
export const DivContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 65%;
  padding-left: 5px;
`;

export const DivContainer1 = styled(Box)`
  width: 35%;
`;

export const LocationGroupText = styled(Typography)`
  font-size: 14px;
  font-weight: 300;
`;

export const LocationGroupButton = styled(Button)(
  ({ theme }) => `
    color: ${theme.palette.primary.main};
  `,
);

export const Container = styled(Box)`
  width: 90%;
  overflow-y: scroll;
  max-height: 335px;
  &::-webkit-scrollbar {
    width: 0px;
  }
`;
